'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var shallowEqual = {};

exports.__exports = shallowEqual;
